import React, { useReducer, useEffect, useState } from "react";
import { Button, Form, Modal, Icon } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../Reducer/InitialStateReducer";
import { server } from "../../App";
import axios from "axios";
import { columnDefs, defaultColDef } from "./CrudOptionsGridParams/GridParams"
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";


function CrudOptions(props) {
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);

  const { category } = props;
  const [rowData, setRowData] = useState([])




  async function getALLDropdown_Options() {
    await axios
      .get(`${server}Dropdown_Options/GetAllOptions/${category}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        setRowData(response.data)
      });
  }

  useEffect(() => {
    getALLDropdown_Options()
  }, [])




  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        key1: "",
        category: "",
        value: "",
      };
      dispatch({
        type: ACTION.LOAD_CRUD_OPTIONS,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      dispatch({
        type: ACTION.LOAD_CRUD_OPTIONS,
        value: clientArray,
      });
    }
  };

  // console.log(state)

  const onCellValueChanged = async ({ data }) => {

    axios({
      method: "put",
      responseType: "json",
      url: `${server}Dropdown_Options/UpdateOneOption/${category}/${data.key1}`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        getALLDropdown_Options()
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };


  function deleteOneOption(params) {

    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Dropdown_Options/DeleteOneOption/${category}/${state.key1}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {

        getALLDropdown_Options()
      })
      .catch((err) => {
        console.log(err);

      });

  }

  let deletebtn = <Button
    style={{ position: "absolute", right: "0.6rem", top: "5.5rem" }}
    icon
    color="red"
    onClick={() => deleteOneOption()}
  // floated="right"
  >

    <Icon name="trash" size='large' />
  </Button>



  return (
    <>
      <Button
        className="btntoshrink"
        color="black"
        onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
      >
        +
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header className="centertextnow">Modifier ou supprimer une option</Modal.Header>
        <Modal.Content>
          <Form>
            <div
              id="myGrid"
              className="ag-theme-alpine"
              style={{
                height: "60vh",
                width: "66.6%",
              }}
            >
              <AgGridReact
                rowData={rowData}
                animateRows={true}
                sortingOrder={["desc", "asc", null]}
                onGridReady={onGridReady}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowSelection={"single"}
                onSelectionChanged={onSelectionChanged}
                undoRedoCellEditing={true}
                undoRedoCellEditingLimit={40}
                onCellValueChanged={onCellValueChanged}
              ></AgGridReact>
            </div>
          </Form>
          {deletebtn}
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>

        </Modal.Actions>
      </Modal>
    </>
  );
}

export default CrudOptions;
